import React, { useState } from 'react';
import { Icon, Divider, Header, Loader, Message, Modal } from 'semantic-ui-react';
import { tap, finalize } from 'rxjs/operators';
import request from 'services/http';
import { DateTime } from 'luxon';

import PageHeader from 'components/PageHeader';

import './visualizar.scss';
import FormularioPesquisa from './FormularioPesquisa';
import Carrossel from './Carrossel';

export default function Visualizar() {
    const [measures, setMeasures] = useState([]);
    const [visualData, setVisualData] = useState({
        loading: false,
        hasSearched: false,
        pagesAmount: 0,
        actualPage: 0,
        query: '',
        notFind: '',
    });

    const insertPoints = (info) => {
        if (!info) {
            return '';
        }
        const infoString = String(info).split('').reverse();
        const result = [];
        const length = infoString.length;

        let counter = 0;

        for (const i of infoString) {
            if (counter > 0 && counter % 3 === 0 && i !== length) {
                result.push('.');
            }
            result.push(i);
            counter++;
        }
        return result.reverse();
    };

    const handleData = (query, page = 1) => {
        setVisualData({ ...visualData, loading: true });
        const req = request({
            method: 'GET',
            url: `/combustivel/afericao/?${query}${query ? '&' : ''}page=${page}`,
        })
            .pipe(
                tap(({ response }) => {
                    if (!response.data[0]) {
                        setVisualData({
                            ...visualData,
                            loading: false,
                            hasSearch: false,
                            notFind: 'Nenhuma aferição encontrada',
                        });
                        return;
                    }
                    setVisualData({
                        ...visualData,
                        loading: false,
                        hasSearch: true,
                        pagesAmount: response.pagesAmount,
                        actualPage: page,
                        query,
                        notFind: '',
                    });
                    return setMeasures(response.data);
                }),
                finalize(() => req.unsubscribe()),
            )
            .subscribe();
    };

    const handlePages = (page) => {
        if (page === visualData.actualPage || page < 1 || page > visualData.pagesAmount) {
            return;
        }
        handleData(visualData.query, page);
    };

    const createPageHandle = () => {
        const pages = [];
        const page = visualData.actualPage;

        if (page - 1 > 1) {
            pages.push(
                <div onClick={() => handlePages(1)} key="-2" className="pagination-item">
                    <p>{1}</p>
                </div>,
            );
        }

        if (page > 1) {
            pages.push(
                <div onClick={() => handlePages(page - 1)} key="-1" className="pagination-item">
                    <p>{page - 1}</p>
                </div>,
            );
        }

        pages.push(
            <div key="0" className="pagination-item actual">
                <p>{page}</p>
            </div>,
        );

        if (page < visualData.pagesAmount) {
            pages.push(
                <div onClick={() => handlePages(page + 1)} key="1" className="pagination-item">
                    <p>{page + 1}</p>
                </div>,
            );
        }

        if (page + 1 < visualData.pagesAmount) {
            pages.push(
                <div
                    onClick={() => handlePages(visualData.pagesAmount)}
                    key="2"
                    className="pagination-item"
                >
                    <p>{visualData.pagesAmount}</p>
                </div>,
            );
        }

        return pages;
    };

    const cleanupData = () => {
        setMeasures([]);
        setVisualData({
            loading: false,
            hasSearched: false,
            pagesAmount: 0,
            actualPage: 0,
            query: '',
            notFind: '',
        });
    };

    return (
        <div id="afericao-visualizar-page">
            <>
                <PageHeader />
                <Header as="h3" className="mt-4 ml-4">
                    <Icon.Group size="big">
                        <Icon name="chart pie" className="primary-color" />
                    </Icon.Group>
                    <Header.Content className="primary-color">
                        Análise de dados
                        <Header.Subheader className="secondary-color">
                            <strong>Exibição dos dados inseridos</strong>
                        </Header.Subheader>
                    </Header.Content>
                </Header>

                <Divider fitted style={{ margin: '0 12px 10px 12px', borderTopWidth: '2px' }} />
            </>

            <div>
                <FormularioPesquisa handleData={handleData} cleanup={cleanupData} />
                {visualData.loading ? (
                    <Loader size="medium" content="Buscando dados" />
                ) : !visualData.hasSearch ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Message style={{ width: '60%' }}>
                            <Message.Header>
                                Faça uma busca para realizar uma análise
                            </Message.Header>
                            <p>Insira informações para realizar uma busca</p>
                            {visualData.notFind ? (
                                <p className="not-find">{visualData.notFind}</p>
                            ) : (
                                ''
                            )}
                        </Message>
                    </div>
                ) : (
                    <>
                        <table className="content-table">
                            <thead className="table-header">
                                <tr className="tr-th">
                                    <td className="th-item th-corner-left" rowSpan="2">
                                        Empresa
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        produto
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Bomba
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Bico
                                    </td>
                                    <td className="th-item" colSpan="2">
                                        Aferição
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Amplitude
                                    </td>
                                    <td className="th-item  " rowSpan="2">
                                        Situação
                                    </td>
                                    <td className="th-item" colSpan="2">
                                        Encerrante Mecânico
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Diferença
                                    </td>
                                    <td className="th-item" colSpan="2">
                                        Encerrante Eletrônico
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Diferença
                                    </td>
                                    <td className="th-item" rowSpan="2">
                                        Data
                                    </td>
                                    <td className="th-item th-corner-right" rowSpan="2">
                                        Cupom
                                    </td>
                                </tr>
                                <tr>
                                    <td className="th-item">Rápida</td>
                                    <td className="th-item">Lenta</td>
                                    <td className="th-item">Inicial</td>
                                    <td className="th-item">Final</td>
                                    <td className="th-item">Inicial</td>
                                    <td className="th-item">Final</td>
                                </tr>
                            </thead>
                            <tbody>
                                {measures.map((measure) => {
                                    return (
                                        <tr className="td-row" key={measure.id}>
                                            <td className="td-item">{measure.nome_red}</td>
                                            <td className="td-item">{measure.produto}</td>
                                            <td className="td-item">{measure.bico}</td>
                                            <td className="td-item">{measure.tanque}</td>
                                            <td className="td-item">{measure.rapida}</td>
                                            <td className="td-item">{measure.lenta}</td>
                                            <td className="td-item">
                                                {Math.abs(measure.lenta - measure.rapida)}
                                            </td>
                                            <td className="td-item">
                                                {Math.abs(measure.lenta - measure.rapida) >= 40
                                                    ? 'Acompanhar'
                                                    : 'Ok'}
                                            </td>
                                            <td className="td-item">
                                                {insertPoints(measure.mec_ini)}
                                            </td>
                                            <td className="td-item">
                                                {insertPoints(measure.mec_fim)}
                                            </td>
                                            <td className="td-item">
                                                {measure.mec_fim - measure.mec_ini}
                                            </td>
                                            <td className="td-item">
                                                {insertPoints(measure.elet_ini)}
                                            </td>
                                            <td className="td-item">
                                                {insertPoints(measure.elet_fim)}
                                            </td>
                                            <td className="td-item">
                                                {parseInt(
                                                    (measure.elet_fim - measure.elet_ini) / 1000,
                                                )}
                                            </td>
                                            <td className="td-item">
                                                {DateTime.fromFormat(
                                                    measure.started_at,
                                                    'yyyy-MM-dd hh:mm:ss',
                                                ).toFormat('dd/MM/yyyy')}
                                            </td>
                                            <td className="td-item">
                                                <Modal
                                                    trigger={
                                                        <Icon
                                                            name="eye"
                                                            size="large"
                                                            className="cupom-icon"
                                                        />
                                                    }
                                                >
                                                    <Modal.Header>Fotos das aferições</Modal.Header>
                                                    <Carrossel measure={measure.afericao} />
                                                </Modal>
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr className="infos-container">
                                    <td colSpan="5" className="table-infos">
                                        {measures.length} itens encontrados
                                    </td>
                                    <td colSpan="5" className="table-infos">
                                        Página {visualData.actualPage}
                                    </td>
                                    <td colSpan="5" className="table-infos">
                                        Acompanhar{' '}
                                        {
                                            measures
                                                .map((measure) =>
                                                    Math.abs(measure.lenta - measure.rapida),
                                                )
                                                .filter((measure) => measure >= 40).length
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="pagination-cell">
                            <div className="pagination">
                                <div onClick={() => handlePages(visualData.actualPage - 1)}>
                                    <Icon size="large" name="angle left" />
                                </div>

                                {createPageHandle()}

                                <div onClick={() => handlePages(visualData.actualPage + 1)}>
                                    <Icon size="large" name="angle right" />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
